import { axios_institute_private } from "../api/setup.intersepter";

export const DeleteEntity = (body: any) => {
  const { type, ...filteredBody } = body;

  let url = "";
  if (type === "course") {
    url = "/course";
  } else if (type === "batch") {
    url = "/batch";
  } else if (type === "lead") {
    url = "/nurture/lead";
  } else if (type === "team") {
    url = "/team";
  } else {
    throw new Error("Invalid type provided");
  }

  return axios_institute_private({
    method: "DELETE",
    url,
    data: filteredBody,
  });
};
